export default {
    campaignCategoryParentList: [],
    campaignCategoryList: [],
    campaignCategoryListCount: 0,
    campaignCategoryListForCreate: [],
}